import React from 'react';
import PropTypes from 'prop-types';

import { Container } from '@mui/material';

// ==============================|| MAIN CONTAINER ||============================== //

const MainContainer = ({ children, sx }) => {
  return (
    <Container
      maxWidth={'lg'}
      sx={{
        px: { xs: 0, sm: 2 },
        position: 'relative',
        left: 0,
        top: 0,
        display: 'flex',
        flexDirection: 'column',
        ...sx,
      }}
    >
      {children}
    </Container>
  );
};

MainContainer.propTypes = { children: PropTypes.node.isRequired, sx: PropTypes.any };

export default MainContainer;
